import styled from 'styled-components';
import * as grid from 'view/styles/grid';
import { h600 } from 'view/styles/fonts';
import { token } from '@atlaskit/tokens';

export const Container = styled.div`
    text-align: center;

    > * {
        margin-bottom: ${token('space.300', '24px')};
    }

    > *:last-child {
        margin-bottom: 0;
    }
`;

export const Title = styled.div`
    ${h600};
    margin-bottom: ${token('space.050', '4px')};
`;

export const IconContainer = styled.div`
    width: ${grid.multiple(10.5).px};
    margin: 0 auto ${token('space.300', '24px')} auto;
`;
